import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { ResearchFilterUI } from './ui';

export class ResearchFilter extends PureComponent {
    static displayName = 'ResearchFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'researchFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <ResearchFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const ResearchFilterContainer = compose()(ResearchFilter);
